import { useRouteLoaderData } from 'react-router-dom';
import { components } from '@mosey/api-types';

export const useUser = () => {
  const user = useRouteLoaderData(
    'user',
  ) as components['schemas']['HandbookUser'];
  return user;
};
